import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../Global/loader.js'
import { FaPlus } from 'react-icons/fa'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import { AiFillEdit } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import { Button } from 'react-bootstrap'
import CreateUser from './CreateUser.js'
import UpdateUser from './UpdateUser.js'
import getUsersList from '../../../API/Admin/GetUsersList.js'
import deleteUser from '../../../API/Admin/DeleteUser.js'
import { BsBackspaceFill } from 'react-icons/bs'

class Users extends React.Component {
  
    state={
        loading: true,
        create: false,
        showDeleteModal: false,     
        uuidForDelete: "",  
        showOneUser: false,
        premesisList: [],
        
        customStyles: {
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                //marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                color: 'red'
            }
        },

        columns:[{
            dataField: 'username',
            text: 'Username',
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"},    
          }, {
            dataField: 'email',
            text: 'Email',
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"}   
        }, {
            dataField: 'firstName',
            text: 'Ime',
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"}
        }, {
          dataField: 'lastName',
          text: 'Prezime',
          style: {wordWrap: "break-word"},
          headerStyle: {wordWrap: "break-word"}
        }, {
            dataField: 'enabled',
            text: 'Aktivan',
            headerStyle: {wordWrap: "break-word"},
            formatter: (cellContent, row) => {          
              return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    <span style={{ color: row.enabled ? "green": "red"}}>
                        <strong>
                            { row.enabled ?  "Da" : "Ne" }
                        </strong>
                    </span>
                </div>
              );
            }
        }, {
            dataField: 'accountNonLocked',
            text: 'Zaključan',
            headerStyle: {wordWrap: "break-word"},
            formatter: (cellContent, row) => {          
              return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    <span style={{ color: row.accountNonLocked ? "green": "red"}}>
                        <strong>
                            { !row.accountNonLocked ?  "Da" : "Ne" }
                        </strong>
                    </span>
                </div>
              );
            }
        }, {
            dataField: 'pregled',
            isDummyField: true,
            text: '',
            headerStyle: (colum, colIndex) => {
                return { width: '11em' };
            },
            formatter: (cellContent, row) => {          
              return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    <div 
                        className="btn btn-warning" 
                        id={row.uuid} 
                        onClick={() =>this.seeDetails(row)} 
                        style={{marginBottom: "10px", marginRight: "10px", fontSize: "13px"}}
                    > 
                        <AiFillEdit /> Detalji 
                    </div> 

                    <div 
                        className="btn btn-danger"
                        id={row.uuid}
                        onClick={() => this.showDeleteModal(row.uuid)}
                        style={{marginBottom: "10px", fontSize: "13px"}}
                    >
                        <RiDeleteBin5Line /> Izbriši
                    </div> 
                   
                </div>
                
              );
            }
        }]        
        
    }

    componentDidMount = async () => {
        this.setState({
            loading: true
        })  

        let usersList = await getUsersList(this.props.oneClientInfo.uuid)
        if(usersList.data.status === 200){
            this.props.mapState("ADMIN_MAP_USERS_LIST", usersList.data.data)
        }
        else{
            this.props.mapState("ADMIN_MAP_USERS_LIST", [])
            
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom dohvata Korisnika, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
            
        }
        
        
        this.setState({
            loading: false
        })
        
    }

    handleChange(e){      
        this.setState({
            [e.target.id]: e.target.value
        })        
    }

    toggleCreate(){
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    backFromEdit(){        
        this.setState({
            showOneUser: !this.state.showOneUser
        })
        this.componentDidMount()
    }

    showDeleteModal = uuid => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid
        });
    };

    confirmDelete = async () => {
        
        let deletedUser = await deleteUser(this.props.oneClientInfo.uuid, this.state.uuidForDelete)   
        if(deletedUser.data.status === 200){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })     
            await store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom brisanja korisnika, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            }) 

            await store.addNotification({
                title: "Uspješno!",
                message: "Brisanje korisnika je izvršeno.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }

    seeDetails = async (data) => {
        await this.props.mapState("ADMIN_MAP_ONE_USER", data)
        await this.setState({
            showOneUser: !this.state.showOneUser
        })
    }

    backFromEdit = async () =>{
        await this.setState({
            showOneUser: !this.state.showOneUser
        })

        this.componentDidMount()
    }

    handleUpdateChange = async (e) => {
        await this.props.mapState("ADMIN_CHANGE_ONE_USER_DETAILS", e.target) 
    }

    goBack(){
        window.location = "#/Admin/client/"
    }
   
    render(){  
        const { loading, create, showOneUser } = this.state 

    return (
        <>
        {loading ? 
            <Loader />
        :
            <>
                {showOneUser? 
                    <UpdateUser goBack={() => this.backFromEdit()} />
                :
                create ? 
                    <CreateUser goBack={() => this.backFromCreate()} />
                :
                    <>

                        <div style={{padding:"20px", float: "right"}}>
                            <div className="btn btn-success" style={{fontSize: "16px"}} onClick={() => this.toggleCreate()}>
                                <FaPlus size={20} /> <span style={{verticalAlign: "middle"}} >Kreiraj</span>
                            </div>
                        </div>
                
                        <BootstrapTable
                            keyField="uuid" 
                            data={ this.props.usersList } 
                            columns={ this.state.columns }   
                            bodyStyle={{wordBreak: 'break-word'} }                    
                        />
                
                        <Modal
                            isOpen={this.state.showDeleteModal}                
                            onRequestClose={() => this.showDeleteModal("")}
                            style={this.state.customStyles}
                            contentLabel="Example Modal"
                        >
            
                            <h1 style={{padding:"20px"}}><strong>Upozorenje!</strong></h1>
                        
                            <div className="" style={{padding: "20px"}}>
                                Brisanjem Korisnika obrisat će se i ostali podaci koji su vezani uz njega.                                
                            </div>

                            <div className="row">
                                <div className="col col-sm-6">
                                    <Button variant="primary" size="lg" onClick={() => this.showDeleteModal("")}>Zatvori</Button>
                                </div>
                                <div className="col col-sm-6">
                                    <Button variant="danger" size="lg" onClick={() => this.confirmDelete()}> IZBRIŠI</Button>
                                </div>                
                            </div>
                    
                        </Modal> 
                        <div 
                            className="btn btn-default" 
                            style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                            onClick={() => this.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>Nazad</strong>                    
                        </div>   
                    </>
                }  
                            
            </>
            
        }
        </>
    )
}
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        usersList: state.adminClient.usersList,
        oneUser: state.adminClient.oneUser,

    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Users);


